import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useDevelopmentLiveUpdates} from '../../../hooks/use-development-live-updates'
import {pullRequestsLayoutRoute} from '../../../routes/layout-route'
import {useDevelopmentQuery} from './route-queries'

export function useDevelopment() {
  const {data: layoutData} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  useDevelopmentLiveUpdates(layoutData?.aliveChannels)

  return useDevelopmentQuery()
}
